import * as React from 'react';
import shortid from 'shortid';
import {
  getSearchParams,
  getTranslatedAdult,
  getTranslatedChild,
  getTranslatedPeopleCount,
  getTranslatedChildAges,
  getTranslatedChildAgeLte12,
} from '../helper/accommodation_helper';

const ADULTS_MIN = 1;
const ADULTS_MAX = 9;
const CHILDREN_MIN = 0;
const CHILDREN_MAX = 6;

const ChildAgeOptions = props => {
  return (
    <React.Fragment>
      {Array.from(new Array(13)).map((_, i) => {
        return <option key={shortid()}>{i}</option>;
      })}
    </React.Fragment>
  );
}

const ChildAgeSelects = props => {
  const { childAges, onChangeChildAge } = props;

  const handleChange = (event, i) => {
    onChangeChildAge(event.target.value, i);
  }

  return (
    <React.Fragment>
      {childAges.map((age, i) => {
          return (
            <li key={shortid()}>
              <dl>
                <dt>{getTranslatedChild()} {i+1}</dt>
                <dd>
                  <select style={{ fontSize: 16 }} name="rooms[0][child_ages][]" value={age} onChange={event => handleChange(event, i)}>
                    <ChildAgeOptions />
                  </select>
                  <i className="fas fa-sort"></i>
                </dd>
              </dl>
            </li>
          );
      })}
    </React.Fragment>
  );
}

class PeopleInputUI extends React.Component<any, any> {
  constructor(props) {
    super(props)
    this.state = {
      adults: 2,
      children: 0,
      childAges: [],
    }
  }
  componentWillMount() {
    const searchParams = getSearchParams();

    if (searchParams.rooms) {
      const room = searchParams.rooms[0]; // 複数部屋検索対応までは[0]

      if (room.adults != null) {
        this.setState({
          adults: Number(room.adults),
        });
      }
      if (room.children != null) {
        this.setState({
          children: Number(room.children),
        });
      }

      let childCount = parseInt(room.children);
      if (childCount >= 1) {
        if (room.child_ages && room.child_ages.length >= 1) {    
          const childAges = room.child_ages.map(age => Number(age));    
          this.setState({
            childAges: childAges.slice(0, childCount),
          });
        }
      } else {
        this.setState({
          childAges: [],
        });
      }
    }
  }

  minusAdults() {
    const { adults } = this.state;
    if (adults <= ADULTS_MIN) return;
    const newAdults = this.minus(adults, ADULTS_MIN);
    this.setState({
      adults: newAdults,
    });
  }

  plusAdults() {
    const { adults } = this.state;
    if (adults >= ADULTS_MAX) return;
    const newAdults = this.plus(adults, ADULTS_MAX);
    this.setState({
      adults: newAdults,
    });
  }

  minusChildren() {
    const { children, childAges } = this.state;
    if (children <= CHILDREN_MIN) return;
    const newChildren = this.minus(children, CHILDREN_MIN);

    if (newChildren >= 1) {
      const newChldAges = 
      this.setState({
        children: newChildren,
        childAges: childAges.slice(0, newChildren),
      });
    } else {
      this.setState({
        children: newChildren,
        childAges: [],
      });
    }
  }

  plusChildren() {
    const { children, childAges } = this.state;
    if (children >= CHILDREN_MAX) return;
    const newChildren = this.plus(children, CHILDREN_MAX);
    const newChildAges = childAges.concat([0]);

    if (newChildren >= 1) {
      this.setState({
        children: newChildren,
        childAges: newChildAges,
      });
    } else {
      this.setState({
        children: newChildren,
        childAges: [],
      });
    }
  }

  plus(num: number, max: number) {
    let newNumber;
    if (num < max) {
      newNumber = Number(num) + 1;
    } else {
      newNumber = max;
    }
    return newNumber;
  }

  minus(num: number, min: number) {
    let newNumber;
    if (num > min) {
      newNumber = Number(num) - 1;
    } else {
      newNumber = min;
    }
    return newNumber;
  }

  handleChangeChildAge(age, i) {
    const { childAges } = this.state;
    if (childAges.length >= (i + 1)) {
      childAges[i] = Number(age);
      this.setState({
        childAges: childAges,
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="sy_inner_container">
          <div className="sy_people_title">{getTranslatedPeopleCount()}</div>
          <div className="sy_step_layout">
            <div className="sy_step_info">
              <div className="sy_info_title">{getTranslatedAdult()}</div>
              <div className="sy_info_description"></div>
            </div>
              
            <div className="sy_button_container">
              <div
                className={`sy_count_button sy_button_down ${this.state.adults === ADULTS_MIN ? "sy_count_button_disabled" : ""}`}
                onClick={this.minusAdults.bind(this)}
              />
              <input className="sy_count_number" name="rooms[0][adults]" value={this.state.adults} readOnly />
              <div
                className={`sy_count_button sy_button_up ${this.state.adults === ADULTS_MAX ? "sy_count_button_disabled" : ""}`}
                onClick={this.plusAdults.bind(this)}
              />
            </div>
          </div>
          <div className="sy_step_layout last">
            <div className="sy_step_info">
              <div className="sy_info_title">{getTranslatedChild()}</div>
              <div className="sy_info_description">{getTranslatedChildAgeLte12()}</div>
            </div>
            <div className="sy_button_container">
              <div
                className={`sy_count_button sy_button_down ${this.state.children === CHILDREN_MIN ? "sy_count_button_disabled": ""}`}
                onClick={this.minusChildren.bind(this)}
              />
              <input className="sy_count_number" name="rooms[0][children]"type="text" value={this.state.children} readOnly />
              <div
                className={`sy_count_button sy_button_up ${this.state.children === CHILDREN_MAX ? "sy_count_button_disabled" : ""}`}
                onClick={this.plusChildren.bind(this)}
              />
            </div>
          </div>
        </div>
        { this.state.children >= 1 &&
          <React.Fragment>
            <div className="box__divider" />
            <div className="sy_inner_container last">
              <label className="sy_plan_label">{getTranslatedChildAges()}</label>
              <div className="form-group custom-form-group">
                <ul className="clearfix">
                  <ChildAgeSelects childAges={this.state.childAges || []} onChangeChildAge={this.handleChangeChildAge.bind(this)} />
                </ul>
              </div>
            </div>
          </React.Fragment>
          }
      </React.Fragment>
    );
  }
}

export default PeopleInputUI;
